import axios from "axios";
const apiPrefix = '/api';

const publishResume = async (data) => {
    const response = await axios.post(`${apiPrefix}/resume/snapshot`, data, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });

    return response.data.data;
};

const getPublishedResumes = async (query) => {
    const response = await axios.get(`${apiPrefix}/resume/shared${query}`);

    return response.data;
};

const getSavedResumes = async (parameters) => {
    const response = await axios.get(`${apiPrefix}/resume/bookmark${parameters}`);
    return response.data;
};

const addResumeToBookmarks = async (resumeId) => {
    const response = await axios.post(`${apiPrefix}/resume/snapshot/${resumeId}/bookmark`);
    return response.data.bookmark;
};

const removeResumeFromBookmarks = async (resumeId) => {
    const response = await axios.delete(`${apiPrefix}/resume/snapshot/${resumeId}/bookmark`);
    return response.data.data;
}

const addComment = async (snapshotId, comment) => {
    const response = await axios.post(`${apiPrefix}/resume/snapshot/${snapshotId}/comments`, {
        comment
    });
	
    return response.data.comment;
}

const vote = async (snapshotId, vote) => {
    const response = await axios.post(`${apiPrefix}/resume/snapshot/${snapshotId}/vote`, {
        vote
    });
    return response.data.data;
}

const getAllComments = async (snapshotId) => {
    const response = await axios.get(`${apiPrefix}/resume/snapshot/${snapshotId}/comments`);
    
    return response.data.data;
}

const getResumes = async (parameters) => {
    const response = await axios.get(`${apiPrefix}/resume/shared${parameters}`);
    
    return response.data;
}

const duplicateResume = async (snapshotId) => {
    const response = await axios.get(`${apiPrefix}/resume/snapshot/${snapshotId}/duplicate`);

    return response.data.data;
}

const deleteComment = async (commentId) => {
	const response = await axios.delete(`${apiPrefix}/comment/${commentId}`);
	
	return response.data.comment;
}

const reportComment = async (commentId, reportBody) => {
    const response = await axios.post(`${apiPrefix}/comment/${commentId}/report`, reportBody);

    return response.data.comment;
}

export default {
    publishResume,
    getPublishedResumes,
    getSavedResumes,
    addResumeToBookmarks,
    comments: {
        add: addComment,
        getAll: getAllComments,
		delete: deleteComment,
        report: reportComment
    },
    resume: {
        vote,
        search: getResumes,
        unsave: removeResumeFromBookmarks,
        duplicate: duplicateResume
    }
};
